module.exports = __webpack_public_path__ + "src/assets/games/6/feiji2.png";